import { brandEmail, brandName, statsBoard } from "@/mocks/gossip";
import SectionHeading from "./SectionHeading";

export default function AboutContact() {
  return (
    <section id="about" className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-6xl px-4 md:px-6 lg:px-8">
        {/* stats band */}
        <div className="grid grid-cols-2 gap-3 md:grid-cols-4 md:gap-5">
          {statsBoard.map((s) => (
            <div
              key={s.label}
              className="flex flex-col items-center rounded-2xl bg-background-50 px-4 py-6 text-center ring-1 ring-background-200/70"
            >
              <span className="font-heading text-3xl font-bold text-primary-600 md:text-4xl">{s.value}</span>
              <span className="mt-2 text-sm text-foreground-600">{s.label}</span>
            </div>
          ))}
        </div>

        <div className="mt-14 grid grid-cols-1 gap-10 lg:grid-cols-2 lg:gap-14">
          {/* About text */}
          <div>
            <SectionHeading
              eyebrow="关于我们"
              title={`跟紧大部队，${brandName}不迷路`}
              desc="一个为吃瓜群众准备的围观集合地。我们不生产瓜，只负责把瓜帮你摆整齐。"
              align="left"
            />
            <div className="mt-6 flex flex-col gap-4 text-sm leading-7 text-foreground-700">
              <p>
                无论是刚落地的热搜大瓜，还是需要蹲后续的连续剧，很多朋友总在“瓜从哪吃起”上卡住。{brandName}
                把散落各处的热门事件按「蹲后续、连麦开撕、正面回应、爆料现场」分类整理，配上清晰的入口、进度状态和指路合集，让你一进来就知道该往哪看。
              </p>
              <p>
                我们坚持三条内容原则：入口清晰、更新及时、来源标注。事件仍在发酵时，我们会如实标记为「蹲更中」「有更新」或「存疑待核」，把不确定性也摆上桌面，帮你理性吃瓜。
              </p>
            </div>
            <ul className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-2">
              {["入口清晰，不迷路", "更新及时，蹲得住", "来源标注，可核实", "理性围观，不传谣"].map((item) => (
                <li
                  key={item}
                  className="flex items-center gap-2.5 rounded-xl bg-background-50 px-4 py-3 text-sm font-medium text-foreground-800 ring-1 ring-background-200/70"
                >
                  <i className="ri-checkbox-circle-line text-primary-500"></i>
                  {item}
                </li>
              ))}
            </ul>
          </div>

          {/* Contact card */}
          <div className="lg:pl-2">
            <div className="flex h-full flex-col rounded-3xl bg-background-950 p-8 md:p-10">
              <h3 className="font-heading text-2xl font-bold text-background-50">联系我们 / 爆料投稿</h3>
              <p className="mt-3 text-sm leading-7 text-background-50/70">
                发现遗漏的现场、想求一个指路入口，或对站内内容有疑问，都可以通过邮箱与我们联系。收到后会尽快处理。
              </p>
              <a
                href={`mailto:${brandEmail}`}
                className="mt-6 inline-flex items-center gap-3 whitespace-nowrap rounded-2xl bg-background-50/5 px-5 py-4 ring-1 ring-background-50/15 transition-colors hover:bg-background-50/10"
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-accent-500 text-background-50">
                  <i className="ri-mail-send-line text-xl"></i>
                </span>
                <span>
                  <span className="block text-xs text-background-50/60">官方邮箱</span>
                  <span className="block text-base font-semibold text-background-50">{brandEmail}</span>
                </span>
              </a>
              <div className="mt-8 flex flex-wrap gap-2">
                {["蹲后续", "催更", "指路合集", "名场面回放"].map((k) => (
                  <span
                    key={k}
                    className="rounded-full bg-primary-500/15 px-3 py-1 text-xs font-medium text-primary-200"
                  >
                    #{k}
                  </span>
                ))}
              </div>
              <p className="mt-auto pt-8 text-xs leading-6 text-background-50/45">
                温馨提示：站内事件均为公开讨论与直播内容的资讯整理，仅供娱乐参考，具体以当事人与官方口径为准。请理性吃瓜，避免传播未经证实的信息。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}